export default {
    chatScreen:{
        title: 'Savvy',
        loading: 'Loading...',
        placeholder: 'Ask me a question',
        buttonTitle: 'Ask Savvy'
    }
}